{
    "name": "client-app",
    "version": "1.1.30",
    "scripts": {
        "ng": "ng",
        "start": "ng serve",
        "build": "ng build",
        "watch": "ng build --watch --configuration development",
        "test": "ng test",
        "lint": "ng lint"
    },
    "private": true,
    "dependencies": {
        "@angular/animations": "^19.1.7",
        "@angular/cdk": "^19.1.5",
        "@angular/common": "^19.1.7",
        "@angular/compiler": "^19.1.7",
        "@angular/core": "^19.1.7",
        "@angular/forms": "^19.1.7",
        "@angular/material": "^19.1.5",
        "@angular/platform-browser": "^19.1.7",
        "@angular/platform-browser-dynamic": "^19.1.7",
        "@angular/router": "^19.1.7",
        "@fortawesome/angular-fontawesome": "^1.0.0",
        "@fortawesome/fontawesome-svg-core": "^6.7.2",
        "@fortawesome/free-solid-svg-icons": "^6.7.2",
        "@ngx-translate/core": "^16.0.4",
        "@ngx-translate/http-loader": "^16.0.1",
        "@ngxmc/datetime-picker": "^19.1.0",
        "guid-typescript": "^1.0.9",
        "hammerjs": "^2.0.8",
        "ng-apexcharts": "^1.15.0",
        "ngx-spinner": "^19.0.0",
        "ngx-toastr": "^19.0.0",
        "rxjs": "~7.8.2",
        "tslib": "^2.8.1",
        "xlsx": "https://cdn.sheetjs.com/xlsx-0.20.3/xlsx-0.20.3.tgz",
        "zone.js": "~0.15.0"
    },
    "devDependencies": {
        "@angular-devkit/build-angular": "^19.1.8",
        "@angular-eslint/builder": "19.1.0",
        "@angular-eslint/eslint-plugin": "19.1.0",
        "@angular-eslint/eslint-plugin-template": "19.1.0",
        "@angular-eslint/schematics": "19.1.0",
        "@angular-eslint/template-parser": "19.1.0",
        "@angular/cli": "^19.1.8",
        "@angular/compiler-cli": "^19.1.7",
        "@types/jasmine": "~5.1.7",
        "@types/node": "^22.13.5",
        "@typescript-eslint/eslint-plugin": "^8.24.1",
        "@typescript-eslint/parser": "^8.24.1",
        "eslint": "^9.21.0",
        "jasmine-core": "~5.6.0",
        "karma": "^6.4.4",
        "karma-chrome-launcher": "~3.2.0",
        "karma-coverage": "~2.2.1",
        "karma-jasmine": "~5.1.0",
        "karma-jasmine-html-reporter": "~2.1.0",
        "typescript": "^5.7.3"
    }
}
